module.exports = __webpack_public_path__ + "img/17_77.3141f8fc.png";